import { updateProfilePicture } from "../api/user-request";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";
import { useCurrentUser } from "./use-current-user";

const updatePicture = async ({
  file,
  userId,
}: {
  file: string | Blob;
  userId: number;
}) => {
  const response = await updateProfilePicture(file, userId);
  return response.data;
};
export const useUpdateProfilePicture = () => {
  const { loadUser } = useCurrentUser();

  return useMutation({
    mutationFn: updatePicture,
    onSuccess: () => {
      toast.success("Update picture successfully!");
      loadUser();
    },
  });
};
